import './manageRsaSignature.scss';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { find } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';

import FormField from '../../../lib/components/form/formField';
import { required, setFormArray } from '../../../lib/utils/form';
import { loadRsaSignaturePieces, saveRsaSignaturePieces } from '../../../store/asyncActions/rsaSignaturePieces';
import { displayActions } from '../../../store/slices/display';

const ManageRsaSignatureDialog = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadRsaSignaturePieces());
    }, [dispatch]);

    const open = useSelector(({ display }) => display.manageRsaSignatureDialog);
    const isSubmitting = useSelector(({ workspace }) => workspace.isSubmitting);

    const requestHeaders = useSelector(({ workspace }) => workspace.requestHeaders);
    const rsaSignaturePieces = useSelector(({ workspace }) => workspace.rsaSignaturePieces);

    const intialValues = useMemo(() => {
        const iv = { ...rsaSignaturePieces, userId: undefined, deviceId: undefined };
        if (requestHeaders && requestHeaders.length) {
            const userIdHeader = find(requestHeaders, { name: 'x-user-id', enabled: true });
            if (userIdHeader) {
                iv.userId = userIdHeader.value;
            }

            const deviceIdHeader = find(requestHeaders, { name: 'x-device-id', enabled: true });
            if (deviceIdHeader) {
                iv.deviceId = deviceIdHeader.value;
            }
        }
        return iv;
    }, [rsaSignaturePieces, requestHeaders]);

    const toggleManageRsaSignature = () =>
        dispatch(displayActions.TOGGLE_MANAGE_RSA_SIGNATURE_DIALOG());

    const submitForm = formData => {
        dispatch(saveRsaSignaturePieces({ ...formData, userId: undefined, deviceId: undefined }));
    };

    return (
        <Dialog
            disableBackdropClick
            open={open}
            onClose={toggleManageRsaSignature}
            aria-labelledby='Manage RSA Signature'
            id='manage_rsa_signature_dialog'
        >
            <DialogTitle>Manage RSA Signature</DialogTitle>

            <DialogContent>
                <Form
                    onSubmit={submitForm}
                    initialValues={intialValues}
                    mutators={{
                        setFormArray
                    }}
                    render={({ form, values, handleSubmit, invalid }) => {
                        const enabled = values.addAutomaticSignature;
                        return (
                            <form onSubmit={handleSubmit} noValidate>
                                <div className='blocked-input'>
                                    <FormField
                                        id='user-id'
                                        name='userId'
                                        label='User Id'
                                        disabled="true"
                                    />
                                    <FormField
                                        id='device-id'
                                        name='deviceId'
                                        label='Device Id'
                                        disabled="true"
                                    />
                                </div>
                                <div className='blocked-input'>
                                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                    <label htmlFor='add-automatic-signature'>Add Signature</label>
                                    <FormField
                                        id='add-automatic-signature'
                                        name='addAutomaticSignature'
                                        type='checkbox'
                                        label='Add Automatic Signature'
                                    />
                                </div>
                                <div className='blocked-input'>
                                    <FormField
                                        id='passphrase'
                                        className='passphrase'
                                        name='passphrase'
                                        label='Passphrase'
                                        required
                                        validate={required}
                                        maxLength={1000000000}
                                        disabled={!enabled}
                                    />
                                    <FormField
                                        id='private-key'
                                        className="private-key"
                                        name='privateKey'
                                        label='Private Key'
                                        required
                                        validate={required}
                                        multiline="true"
                                        maxLength={1000000000}
                                        disabled={!enabled}
                                    />
                                </div>
                                <DialogActions>
                                    <Button color='secondary' onClick={toggleManageRsaSignature}>
                                        Cancel
                                    </Button>
                                    <Button color='primary' disabled={invalid || isSubmitting} onClick={handleSubmit}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </form>
                        );
                    }}
                />
            </DialogContent>
        </Dialog>
    );
};

export default ManageRsaSignatureDialog;